import React, { useState, useRef } from "react";
import {
  Box,
  Grid,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
  Typography,
  Tabs,
  Tab,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
  Paper,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import {
  apiUrl,
  envCode,
  MAX_FILE_SIZE,
  ALLOWED_TYPES,
} from "../Constant";
import Select from "react-select";
import { toast } from "sonner";
import CustomLoader from "../static/CustomLoader";
import AddIcon from "@mui/icons-material/Add";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import HomePage from "../../components/login/pages/HomePage";
import {
  uploadDocument,
  viewDocument,
} from "../utiles/DocumentService";

export default function ViewDocumentPage() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [otp, setOtp] = useState("");
  const [otpDialogOpen, setOtpDialogOpen] = useState(true);
  const [authToken, setAuthToken] = useState("");
  const [factoryCode, setFactoryCode] = useState("");
  const [orgCode, setOrgCode] = useState("");
  const [tabValue, setTabValue] = useState(0);
  const [userData, setUserData] = useState([]);
  const [divData, setDivData] = useState([]);
  const [errors, setErrors] = useState({});
  const [licenseStatus, setLicenseStatus] = useState([]);
  const [hazardCategoryOptions, setHazardCategoryOptions] = useState([]);
  const [sectionData, setSectionData] = useState([]);
  const [sectorData, setSectorData] = useState([]);
  const [workingData, setWorkingData] = useState([]);
  const [ownshirpData, setOwnshirpData] = useState([]);
  const [empTypeData, setEmpTypeData] = useState([]);
  const [id, setId] = useState("");
  const [infoDialogOpen, setInfoDialogOpen] = useState(false);
  const [sessionExpiredOpen, setSessionExpiredOpen] = useState(false);

  const navigate = useNavigate();

  //Basic Details States
  const [user, setUser] = useState(0);
  const [divcode, setDivcode] = useState(null);
  const [licencenumber, setLicencenumber] = useState("");
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [primaryphone, setPrimaryphone] = useState("");
  const [email, setEmail] = useState("");
  const [addressline, setAddressline] = useState("");
  const [pincode, setPincode] = useState("");
  const [city, setCity] = useState("");
  const [dist, setDist] = useState("");
  const [state, setState] = useState("");
  const [country, setCountry] = useState("");
  const [latd, setLatd] = useState("");
  const [longt, setLongt] = useState("");
  const [amendment, setAmendment] = useState("");

  //2 Tab Details
  const [formData, setFormData] = useState({});

  //3 Tab Deatils
  const [directorData, setDirectorData] = useState([
    { firstName: "", lastName: "", contactNumber: "", email: "" },
  ]);

  //4 Tab Deatils
  const [employeeData, setEmployeeData] = useState([
    { employeeType: "", adultMale: "", adultFemale: "" },
  ]);

  const [occupierData, setOccupierData] = useState([
    { firstName: "", lastName: "", contactNumber: "", email: "" },
  ]);

  //5 Tab Details
  const [documents, setDocuments] = useState([
    {
      file: null,
      fileName: "",
      fileType: "",
      filePurpose: "",
      previewUrl: "",
    },
  ]);

  const fileInputRefs = useRef([]);

  const requiredFields = [
    "natureOfManufacturing",
    "horsePower",
    "kilowatt",
    "fees",
    "licenseRenewalStatus",
    "licenseStrength",
    "hazardCategory",
    "coveredUnderSection",
    "sector",
    "workingStatus",
    "ownership",
  ];

  const handleTabChange = (_, newValue) => {
    setTabValue(newValue);
  };

  const handleDirectorChange = (index, field, value) => {
    const updated = [...directorData];
    updated[index][field] = value;
    setDirectorData(updated);
  };

  const addDirector = () => {
    setDirectorData((prev) => [
      ...prev,
      { firstName: "", lastName: "", contactNumber: "", email: "" },
    ]);
  };

  const removeDirector = (index) => {
    const updated = [...directorData];
    updated.splice(index, 1);
    setDirectorData(updated);
  };

  const handleEmployeeChange = (index, field, value) => {
    const updated = [...employeeData];
    updated[index][field] = value;
    setEmployeeData(updated);
  };

  const removeEmployee = (index) => {
    const updated = [...employeeData];
    updated.splice(index, 1);
    setEmployeeData(updated);
  };

  const addEmployee = () => {
    setEmployeeData((prev) => [
      ...prev,
      { employeeType: "", adultMale: "", adultFemale: "" },
    ]);
  };

  const handleFileUpload = async (index, event) => {
    const file = event.target.files[0];
    if (!file) return;

    if (!ALLOWED_TYPES.includes(file.type)) {
      toast.error("Only Images (JPG, PNG) and PDFs are allowed.");
      if (fileInputRefs.current[index]) {
        fileInputRefs.current[index].value = "";
      }
      return;
    }

    if (file.size > MAX_FILE_SIZE) {
      toast.error("File size must be less than 5 MB.");
      if (fileInputRefs.current[index]) {
        fileInputRefs.current[index].value = "";
      }
      return;
    }
    setLoading(true);
    try {
      const folderPath = `${orgCode}/auditee${factoryCode}`;

       const uploadRes = await uploadDocument({
                file,
                projectCode: "Ptw",
                envCode,
                folderPath,
              });
      
              if (uploadRes?.cd === 1) {
                toast.error(uploadRes.description);
                setLoading(false);
                return;
              }
      toast.success("File Uploaded Successfully!");

      const previewUrl = await fetchPreviewFile(
        uploadRes,
        orgCode,
        factoryCode,
      );

      // Update document row
      const updated = [...documents];
      updated[index] = {
        file,
        fileName: uploadRes,
        fileType: file.type,
        previewUrl,
      };

      setDocuments(updated);
    } catch (error) {
      console.error(error);
      toast.error("Upload failed");
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const handlePurposeChange = (index, value) => {
    const updated = [...documents];
    updated[index].filePurpose = value;
    setDocuments(updated);
  };

  const fetchPreviewFile = async (logoName, orgCode, factoryCode) => {
    try {
      const folderPath = `${orgCode}/auditee${factoryCode}`;
            const response = await viewDocument({
              projectCode: "Ptw",
              envCode,
              folderPath,
              fileName: logoName,
            });
      
            if (response.cd === 1) {
              return "";
            }

    const base64Data = response;

        const mimeType = logoName.toLowerCase().endsWith(".pdf")
          ? "application/pdf"
          : "image/*";

        // Convert Base64 → Blob
        const binaryString = atob(base64Data);
        const len = binaryString.length;
        const bytes = new Uint8Array(len);

        for (let i = 0; i < len; i++) bytes[i] = binaryString.charCodeAt(i);

        const blob = new Blob([bytes], { type: mimeType });
        return URL.createObjectURL(blob);
    } catch (e) {
      console.error("Preview fetch error:", e);
    }

    return "";
  };

  const fetchExistingDocuments = async (token, code, orgCode) => {
    const headers = {
      Authorization: token,
      "Content-Type": "application/json",
      dbMaster: "",
    };

    setLoading(true);

    try {
      const res = await axios.get(`${apiUrl}auditeedoc/${code}`, { headers });

      if (res.data.cd === 1) {
        toast.error(res.data.description || "No documents found");
        return;
      }
      if (!res.data || res.data.length === 0) {
        setDocuments([
          {
            file: null,
            fileName: "",
            fileType: "",
            filePurpose: "",
            previewUrl: "",
          },
        ]);
        return;
      }
      const rows = res.data || [];

      // Convert backend data → React documents format
      const mappedDocs = await Promise.all(
        rows.map(async (item) => {
          const previewUrl = await fetchPreviewFile(item.name, orgCode, code);

          return {
            file: null,
            fileName: item.name,
            fileType: item.type,
            filePurpose: item.purpose,
            previewUrl: previewUrl,
          };
        }),
      );

      setDocuments(mappedDocs);
    } catch (err) {
      toast.error("Failed to load existing documents");
    } finally {
      setLoading(false);
    }
  };

  const addDocumentRow = () => {
    setDocuments((prev) => [
      ...prev,
      {
        file: null,
        fileName: "",
        fileType: "",
        filePurpose: "",
        previewUrl: "",
      },
    ]);
  };

  // Delete row
  const removeDocumentRow = (index) => {
    const updated = [...documents];
    updated.splice(index, 1);
    setDocuments(updated);
  };

  const handleGetAuditeeDetails = async (code, token, orgCode) => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${apiUrl}auditee/code/${code}`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        },
      );

      const data = response.data;
      if (data.cd == 1) {
        toast.error(data.description || "Not found");
      } else {
        const industry = JSON.parse(response.data.industry);
        const occupier = response.data.occupier;
        const directores = response.data.manager;
        const employee = response.data.employee;
        setId(data.id);
        setDivcode(data.divcode);
        setLicencenumber(data.licencenumber);
        setName(data.name);
        setDescription(data.description);
        setPrimaryphone(data.primaryphone);
        setEmail(data.email);
        setCity(data.city);
        setPincode(data.pincode);
        setDist(data.dist);
        setState(data.state);
        setCountry(data.country);
        setLatd(data.latd);
        setLongt(data.longt);
        setAmendment(data.amendment);
        setUser(data.user);
        setFormData((prev) => ({
          ...prev,
          divisionCode: industry.divisionCode,
          districtCode: industry.districtCode,
          talukCode: industry.talukCode,
          factoryRegDate: industry.factoryRegDate,
          nicCode: industry.nicCode,
          natureOfManufacturing: industry.natureOfManufacturing,
          horsePower: industry.horsePower,
          kilowatt: industry.kilowatt,
          fees: industry.fees,
          licenseRenewalStatus: industry.licenseRenewalStatus,
          licenseStrength: industry.licenseStrength,
          hazardCategory: industry.hazardCategory,
          coveredUnderSection: industry.coveredUnderSection,
          sector: industry.sector,
          workingStatus: industry.workingStatus,
          ownership: industry.ownership,
          occupierEmail: industry.occupierEmail,
          occupierPhone: industry.occupierPhone,
          occupierAddress: industry.occupierAddress,
          managerEmail: industry.managerEmail,
          managerPhone: industry.managerPhone,
          managerAddress: industry.managerAddress,
          managername: industry.managername,
          occupiername: industry.occupiername,
        }));

        const parsedDirectors = JSON.parse(directores);
        if (Array.isArray(parsedDirectors)) {
          setDirectorData(parsedDirectors);
        }

        const parsedEmployee = JSON.parse(employee);
        if (Array.isArray(parsedEmployee)) {
          setEmployeeData(parsedEmployee);
        }
      }

      await fetchExistingDocuments(token, code, orgCode);
      return response.data;
    } catch (error) {
      console.error("POST /code API failed:", error);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const validateFirstTabForm = () => {
    let newErrors = {};
    if (!user) newErrors.user = "Employee/User is required.";
    if (!divcode) newErrors.divcode = "Division  is required.";
    if (!licencenumber.trim())
      newErrors.licencenumber = "Licence number is required.";
    if (!name.trim()) newErrors.name = "Name is required.";
    if (!pincode) newErrors.pincode = "Pincode is required.";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmitDocuments = async () => {
    setLoading(true);

    const headers = {
      Authorization: authToken,
      "Content-Type": "application/json",
      dbMaster: "",
    };

    try {
      const docList = documents.map((doc) => ({
        auditeecode: factoryCode,
        type: doc.fileType,
        name: doc.fileName,
        purpose: doc.filePurpose,
      }));

      if (docList.length === 0) {
        toast.warning("No documents to save");
        return;
      }

      const response = await axios.post(`${apiUrl}auditeedoc`, docList, {
        headers,
      });

      if (response.data.cd === 1) {
        toast.error(response.data.description || "Document save failed");
      } else {
        toast.success(
          response.data.description || "Documents saved successfully",
        );
      }
    } catch (error) {
      toast.error("Something went wrong while uploading documents.");
    } finally {
      setLoading(false);
    }
  };

  const handlesubmit = async () => {
    const firstTabValid = validateFirstTabForm();

    if (!firstTabValid) {
      setTabValue(1);
      toast.warning("Please fill all requied filed...");
      return;
    }
    setLoading(true);

    const payLoad = {
      id: id,
      code: factoryCode,
      divcode: divcode,
      licencenumber: licencenumber,
      name: name,
      description: description,
      primaryphone: primaryphone,
      email: email,
      addressline: addressline,
      city: city,
      dist: dist,
      state: state,
      country: country,
      pincode: pincode,
      latd: latd,
      longt: longt,
      industry: JSON.stringify(formData),
      occupier: JSON.stringify(occupierData),
      manager: JSON.stringify(directorData),
      employee: JSON.stringify(employeeData),
      amendment: amendment,
      user: user,
    };

    const headers = {
      Authorization: authToken,
      "Content-Type": "application/json",
      dbMaster: "",
    };

    try {
      const response = await axios.put(`${apiUrl}auditee/${id}`, payLoad, {
        headers,
      });
      if (response.data.cd === 1) {
        toast.error(response.data.description);
      } else {
        toast.success(response.data.description);
        const hasDocuments = documents.some(
          (doc) => doc.fileType && doc.fileType.trim() !== "",
        );

        if (hasDocuments) {
          await handleSubmitDocuments();
        }
        setTimeout(() => {
          setSessionExpiredOpen(true);
        }, 500);
      }
    } catch (error) {
      toast.error("Something went wrong while updating data.");
    } finally {
      setLoading(false);
    }
  };

  function clearFields() {
    setErrors({});
    setId("");
    setDivcode(null);
    setLicencenumber("");
    setName("");
    setDescription("");
    setPrimaryphone("");
    setEmail("");
    setAddressline("");
    setCity("");
    setDist("");
    setState("");
    setCountry("");
    setPincode("");
    setLatd("");
    setLongt("");
    setUser(0);
    // Second tab
    setFormData({});

    setDirectorData([
      { firstName: "", lastName: "", contactNumber: "", email: "" },
    ]);

    setEmployeeData([{ employeeType: "", adultMale: "", adultFemale: "" }]);
  }

  const handlefetchOtherApi = async (token) => {
    setLoading(true);

    const headers = {
      Authorization: token,
      "Content-Type": "application/json",
      dbMaster: "",
    };

    // 🟦 Reusable API fetch function
    const fetchOptions = async (url, setter) => {
      try {
        const res = await axios.get(url, { headers });
        const data = res.data;

        if (data.cd === 1) {
          setter([]);
        } else {
          const mapped = data.map((op) => ({
            value: op.code || op.empcode,
            label: op.value || op.userid || op.name,
          }));
          setter(mapped);
        }
      } catch (err) {
        console.error("Error fetching:", url, err);
        setter([]);
      }
    };

    try {
      // 1️⃣ User API
      const userRes = await axios.get(`${apiUrl}user`, { headers });
      const userData = userRes.data;
      if (userData.cd === 1) setUserData([]);
      else {
        const userOptions = userData.map((op) => ({
          value: op.empcode,
          label: op.userid,
        }));
        setUserData(userOptions);
      }

      await fetchOptions(`${apiUrl}division`, setDivData);

      await fetchOptions(`${apiUrl}dropdown/fxid/LRST`, setLicenseStatus);

      await fetchOptions(
        `${apiUrl}dropdown/fxid/HCAT`,
        setHazardCategoryOptions,
      );

      await fetchOptions(`${apiUrl}dropdown/fxid/SCT`, setSectionData);

      await fetchOptions(`${apiUrl}dropdown/fxid/SST`, setSectorData);

      await fetchOptions(`${apiUrl}dropdown/fxid/FWST`, setWorkingData);

      await fetchOptions(`${apiUrl}dropdown/fxid/OWN`, setOwnshirpData);

      await fetchOptions(`${apiUrl}dropdown/fxid/EMPTP`, setEmpTypeData);
    } catch (err) {
      console.error("Fetch error:", err);
    } finally {
      setLoading(false);
    }
  };

  const fetchPincodeDetails = async (enteredPincode) => {
    setLoading(true);
    try {
      const response = await axios.get(
        `https://api.postalpincode.in/pincode/${enteredPincode}`,
      );
      if (
        response.data &&
        response.data.length > 0 &&
        response.data[0].Status === "Success"
      ) {
        const postOffice = response.data[0].PostOffice[0];
        setCity(postOffice.Block || "");
        setDist(postOffice.District || "");
        setState(postOffice.State || "");
        setCountry(postOffice.Country || "");
        setLoading(false);
      } else {
        toast.error("Invalid pincode or details not found.");
        setCity("");
        setDist("");
        setState("");
        setCountry("");
        setLoading(false);
      }
    } catch (error) {
      toast.error("Failed to fetch location from pincode.");
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleOpenWithOTP = async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams(window.location.search);
      const token = params.get("token");
      if (!token) {
        setError("Token missing");
        setLoading(false);
        return;
      }

      // call API with OTP header
      const viewRes = await axios.get(
        `${apiUrl}share/view?token=${encodeURIComponent(token)}`,
        {
          headers: {
            otp: otp,
          },
        },
      );

      const viewJson = viewRes.data;
      if (viewJson.cd !== 0) {
        setError(viewJson.description || "Invalid token/OTP");
        setLoading(false);
        return;
      }
      const { shaduleId, authToken, orgCode } = viewJson;
      setFactoryCode(shaduleId);
      setAuthToken(authToken);
      setOrgCode(orgCode);
      setOtpDialogOpen(false);
      setLoading(false);
      setInfoDialogOpen(true);
      await handlefetchOtherApi(authToken);
      await handleGetAuditeeDetails(shaduleId, authToken, orgCode);
    } catch (err) {
      console.error(err);
      setError("Invalid or missing OTP");
      setLoading(false);
    }
  };

  if (loading) return <CustomLoader />;

  return (
    <Box position="relative" width="100%" height="100vh">
      {/* OTP Dialog */}
      <Dialog open={otpDialogOpen} maxWidth="xs" fullWidth>
        <DialogTitle
          sx={{ textAlign: "center", fontWeight: "bold", color: "#1976d2" }}
        >
          {" "}
          Please enter OTP
        </DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            variant="outlined"
            placeholder="Enter OTP"
            value={otp}
            onChange={(e) => {
              const val = e.target.value;
              if (val.length <= 6) setOtp(val);
            }}
            error={error}
            helperText={error}
            inputProps={{
              maxLength: 6,
              style: {
                fontSize: "1.5rem",
                textAlign: "center",
                letterSpacing: "0.5rem",
              },
            }}
          />
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center", pb: 2 }}>
          <Button
            variant="contained"
            color="primary"
            disabled={otp.length !== 6}
            onClick={handleOpenWithOTP}
            sx={{ px: 4, py: 1 }}
          >
            Open
          </Button>
        </DialogActions>
      </Dialog>

      {!otpDialogOpen && (
        <Box
          sx={{
            backgroundColor: "#f1f5f9",
            padding: "24px",
            width: "100%",
            height: "100vh",
            overflowY: "auto",
            overflowX: "hidden",
            scrollbarWidth: "thin",
            WebkitOverflowScrolling: "touch",
          }}
        >
          {/* TABS INSIDE WHITE BOX */}
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            centered
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
            sx={{
              backgroundColor: "#f1f5f9",
              borderRadius: "4px 4px 0 0",
              "& .MuiTab-root": {
                color: "#444",
                fontWeight: 600,
                fontSize: "14px",
                textTransform: "none",
              },
              "& .Mui-selected": {
                color: "#2962ff",
                fontWeight: 700,
              },
              "& .MuiTabs-indicator": {
                backgroundColor: "#2962ff",
                height: "4px",
                borderRadius: "4px",
              },
            }}
          >
            <Tab label="Parivikshak Overview" sx={{ fontWeight: "bold" }} />
            <Tab label="Basic Details" sx={{ fontWeight: "bold" }} />
            <Tab
              label="Factory Registration Details"
              sx={{ fontWeight: "bold" }}
            />
            <Tab label="Company Director Details" sx={{ fontWeight: "bold" }} />
            <Tab label="Add Employee Details" sx={{ fontWeight: "bold" }} />
            <Tab label="Upload Documents" sx={{ fontWeight: "bold" }} />
          </Tabs>
          <Box sx={{ borderBottom: "2px solid #2962ff", mb: 2 }} />

          {tabValue === 0 && (
            <Box sx={{ mt: 2 }}>
              <HomePage mode="V" />
            </Box>
          )}

          {/* TAB CONTENT */}
          {tabValue === 1 && (
            <>
              <Grid container spacing={2} mt={2}>
                <Grid item xs={12} sm={6} md={3}>
                  <Typography fontWeight="bold">
                    Employee/User <span className="text-danger">*</span>
                  </Typography>
                  <Select
                    isClearable
                    options={userData}
                    value={userData.find((opt) => opt.value === user)}
                    onChange={(selected) => setUser(selected?.value)}
                    placeholder="Select Employee/User"
                  />
                  {errors.user && (
                    <small className="text-danger">{errors.user}</small>
                  )}
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <Typography fontWeight="bold">
                    Division <span className="text-danger">*</span>
                  </Typography>
                  <Select
                    isClearable
                    options={divData}
                    value={divData.find((opt) => opt.value === divcode)}
                    onChange={(selected) => setDivcode(selected?.value)}
                    placeholder="Select Division"
                  />
                  {errors.divcode && (
                    <small className="text-danger">{errors.divcode}</small>
                  )}
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <Typography fontWeight="bold">
                    Licence Number <span className="text-danger">*</span>
                  </Typography>
                  <input
                    className="form-control"
                    type="text"
                    value={licencenumber}
                    onChange={(e) => setLicencenumber(e.target.value)}
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <Typography fontWeight="bold">
                    Name <span className="text-danger">*</span>
                  </Typography>
                  <input
                    className="form-control"
                    type="text"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                  />
                </Grid>
              </Grid>

              {/* SECOND ROW */}
              <Grid container spacing={2} mt={1}>
                <Grid item xs={12} sm={6} md={3}>
                  <Typography fontWeight="bold">Primary Phone</Typography>
                  <input
                    className="form-control"
                    type="text"
                    maxLength={10}
                    value={primaryphone}
                    onChange={(e) => {
                      const value = e.target.value.replace(/\D/g, "");
                      if (value.length <= 10) setPrimaryphone(value);
                    }}
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <Typography fontWeight="bold">Email</Typography>
                  <input
                    className="form-control"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <Typography fontWeight="bold">Address Line</Typography>
                  <input
                    className="form-control"
                    type="text"
                    value={addressline}
                    onChange={(e) => setAddressline(e.target.value)}
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <Typography fontWeight="bold">
                    Pincode <span className="text-danger">*</span>
                  </Typography>
                  <input
                    className="form-control"
                    type="text"
                    value={pincode}
                    maxLength={6}
                    onChange={(e) => {
                      const value = e.target.value.replace(/\D/g, "");
                      setPincode(value);
                      if (value.length === 6) fetchPincodeDetails(value);
                    }}
                  />
                  {errors.pincode && (
                    <small className="text-danger">{errors.pincode}</small>
                  )}
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <Typography fontWeight="bold">City</Typography>
                  <input
                    className="form-control"
                    type="text"
                    value={city}
                    readOnly
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <Typography fontWeight="bold">District</Typography>
                  <input
                    className="form-control"
                    type="text"
                    value={dist}
                    readOnly
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <Typography fontWeight="bold">State</Typography>
                  <input
                    className="form-control"
                    type="text"
                    value={state}
                    readOnly
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <Typography fontWeight="bold">Country</Typography>
                  <input
                    className="form-control"
                    type="text"
                    value={country}
                    readOnly
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <Typography fontWeight="bold">Latitude</Typography>
                  <input
                    className="form-control"
                    type="text"
                    value={latd}
                    onChange={(e) => setLatd(e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <Typography fontWeight="bold">Longitude</Typography>
                  <input
                    className="form-control"
                    type="text"
                    value={longt}
                    onChange={(e) => setLongt(e.target.value)}
                  />
                </Grid>
              </Grid>
            </>
          )}

          {tabValue === 2 && (
            <>
              <Grid container spacing={2} mt={2}>
                <Grid item xs={12} sm={6} md={3}>
                  <Typography fontWeight="bold">
                    Factory Registration Date
                  </Typography>
                  <input
                    className="form-control"
                    type="date"
                    name="factoryRegDate"
                    value={formData.factoryRegDate}
                    onChange={handleInputChange}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <Typography fontWeight="bold">
                    {" "}
                    NIC code of the Factory
                  </Typography>
                  <input
                    className="form-control"
                    type="text"
                    name="nicCode"
                    value={formData.nicCode}
                    onChange={handleInputChange}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <Typography fontWeight="bold">
                    Nature of Manufacturing{" "}
                    <span className="text-danger">*</span>
                  </Typography>
                  <input
                    className="form-control"
                    type="text"
                    name="natureOfManufacturing"
                    value={formData.natureOfManufacturing}
                    onChange={handleInputChange}
                  />
                  {errors.natureOfManufacturing && (
                    <small className="text-danger">
                      {errors.natureOfManufacturing}
                    </small>
                  )}
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <Typography fontWeight="bold">
                    Horse Power (HP) <span className="text-danger">*</span>
                  </Typography>
                  <input
                    className="form-control"
                    type="number"
                    name="horsePower"
                    value={formData.horsePower}
                    onChange={handleInputChange}
                  />
                  {errors.horsePower && (
                    <small className="text-danger">{errors.horsePower}</small>
                  )}
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <Typography fontWeight="bold">
                    {" "}
                    Kilowatt (KW) <span className="text-danger">*</span>
                  </Typography>
                  <input
                    className="form-control"
                    type="number"
                    name="kilowatt"
                    value={formData.kilowatt}
                    onChange={handleInputChange}
                  />
                  {errors.kilowatt && (
                    <small className="text-danger">{errors.kilowatt}</small>
                  )}
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <Typography fontWeight="bold">
                    Fees <span className="text-danger">*</span>
                  </Typography>
                  <input
                    className="form-control"
                    type="text"
                    name="fees"
                    value={formData.fees}
                    onChange={handleInputChange}
                  />
                  {errors.fees && (
                    <small className="text-danger">{errors.fees}</small>
                  )}
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <Typography fontWeight="bold">
                    Factory License Renewal Status{" "}
                    <span className="text-danger">*</span>
                  </Typography>
                  <Select
                    isClearable
                    options={licenseStatus}
                    value={licenseStatus.find(
                      (opt) => opt.value === formData.licenseRenewalStatus,
                    )}
                    onChange={(selected) =>
                      handleInputChange({
                        target: {
                          name: "licenseRenewalStatus",
                          value: selected?.value || "",
                        },
                      })
                    }
                    placeholder="Select Status"
                  />

                  {errors.licenseRenewalStatus && (
                    <small className="text-danger">
                      {errors.licenseRenewalStatus}
                    </small>
                  )}
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <Typography fontWeight="bold">
                    Factory License Strength{" "}
                    <span className="text-danger">*</span>
                  </Typography>
                  <input
                    className="form-control"
                    type="number"
                    name="licenseStrength"
                    value={formData.licenseStrength}
                    onChange={handleInputChange}
                  />
                  {errors.licenseStrength && (
                    <small className="text-danger">
                      {errors.licenseStrength}
                    </small>
                  )}
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <Typography fontWeight="bold">
                    Factory Hazard Category{" "}
                    <span className="text-danger">*</span>
                  </Typography>
                  <Select
                    isClearable
                    options={hazardCategoryOptions}
                    value={hazardCategoryOptions.find(
                      (opt) => opt.value === formData.hazardCategory,
                    )}
                    onChange={(selected) =>
                      handleInputChange({
                        target: {
                          name: "hazardCategory",
                          value: selected?.value || "",
                        },
                      })
                    }
                    placeholder="Select Category"
                  />

                  {errors.hazardCategory && (
                    <small className="text-danger">
                      {errors.hazardCategory}
                    </small>
                  )}
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <Typography fontWeight="bold">
                    Covered under Section <span className="text-danger">*</span>
                  </Typography>
                  <Select
                    isClearable
                    options={sectionData}
                    value={sectionData.find(
                      (opt) => opt.value === formData.coveredUnderSection,
                    )}
                    onChange={(selected) =>
                      handleInputChange({
                        target: {
                          name: "coveredUnderSection",
                          value: selected?.value || "",
                        },
                      })
                    }
                    placeholder="Select Section"
                  />

                  {errors.coveredUnderSection && (
                    <small className="text-danger">
                      {errors.coveredUnderSection}
                    </small>
                  )}
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <Typography fontWeight="bold">
                    Sector <span className="text-danger">*</span>
                  </Typography>
                  <Select
                    isClearable
                    options={sectorData}
                    value={sectorData.find(
                      (opt) => opt.value === formData.sector,
                    )}
                    onChange={(selected) =>
                      handleInputChange({
                        target: {
                          name: "sector",
                          value: selected?.value || "",
                        },
                      })
                    }
                    placeholder="Select Sector"
                  />

                  {errors.sector && (
                    <small className="text-danger">{errors.sector}</small>
                  )}
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <Typography fontWeight="bold">
                    {" "}
                    Factory Working Status{" "}
                    <span className="text-danger">*</span>
                  </Typography>
                  <Select
                    isClearable
                    options={workingData}
                    value={workingData.find(
                      (opt) => opt.value === formData.workingStatus,
                    )}
                    onChange={(selected) =>
                      handleInputChange({
                        target: {
                          name: "workingStatus",
                          value: selected?.value || "",
                        },
                      })
                    }
                    placeholder="Select Working status"
                  />

                  {errors.workingStatus && (
                    <small className="text-danger">
                      {errors.workingStatus}
                    </small>
                  )}
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <Typography fontWeight="bold">
                    Ownership <span className="text-danger">*</span>
                  </Typography>
                  <Select
                    isClearable
                    options={ownshirpData}
                    value={ownshirpData.find(
                      (opt) => opt.value === formData.ownership,
                    )}
                    onChange={(selected) =>
                      handleInputChange({
                        target: {
                          name: "ownership",
                          value: selected?.value || "",
                        },
                      })
                    }
                    placeholder="Select Ownership"
                  />

                  {errors.ownership && (
                    <small className="text-danger">{errors.ownership}</small>
                  )}
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <Typography fontWeight="bold">Occupier Name</Typography>
                  <input
                    className="form-control"
                    type="text"
                    name="occupiername"
                    value={formData.occupiername}
                    onChange={handleInputChange}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <Typography fontWeight="bold">Occupier Email</Typography>
                  <input
                    className="form-control"
                    type="email"
                    name="occupierEmail"
                    value={formData.occupierEmail}
                    onChange={handleInputChange}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <Typography fontWeight="bold"> Occupier Phone</Typography>
                  <input
                    className="form-control"
                    type="text"
                    name="occupierPhone"
                    value={formData.occupierPhone}
                    maxLength={10}
                    onChange={(e) => {
                      const value = e.target.value.replace(/\D/g, "");
                      if (value.length <= 10) {
                        handleInputChange({
                          target: { name: "occupierPhone", value },
                        });
                      }
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <Typography fontWeight="bold"> Occupier Address</Typography>
                  <input
                    className="form-control"
                    type="text"
                    name="occupierAddress"
                    value={formData.occupierAddress}
                    onChange={handleInputChange}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <Typography fontWeight="bold">Manager Name</Typography>
                  <input
                    className="form-control"
                    type="text"
                    name="managername"
                    value={formData.managername}
                    onChange={handleInputChange}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <Typography fontWeight="bold">Manager Email</Typography>
                  <input
                    className="form-control"
                    type="email"
                    name="managerEmail"
                    value={formData.managerEmail}
                    onChange={handleInputChange}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <Typography fontWeight="bold">Manager Phone</Typography>
                  <input
                    className="form-control"
                    type="text"
                    name="managerPhone"
                    value={formData.managerPhone}
                    maxLength={10}
                    onChange={(e) => {
                      const value = e.target.value.replace(/\D/g, "");
                      if (value.length <= 10) {
                        handleInputChange({
                          target: { name: "managerPhone", value },
                        });
                      }
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <Typography fontWeight="bold"> Manager Address</Typography>
                  <input
                    className="form-control"
                    type="text"
                    name="managerAddress"
                    value={formData.managerAddress}
                    onChange={handleInputChange}
                  />
                </Grid>
              </Grid>
            </>
          )}

          {tabValue === 3 && (
            <>
              {directorData.map((director, index) => (
                <Box
                  key={director.id}
                  sx={{
                    border: "1px solid #ddd",
                    borderRadius: 2,
                    mb: 3,
                    p: 3,
                  }}
                >
                  <Grid container spacing={2} mt={2}>
                    <Grid item xs={12} sm={6} md={3}>
                      <Typography fontWeight="bold">First Name</Typography>
                      <input
                        type="text"
                        className="form-control"
                        value={director.firstName}
                        onChange={(e) =>
                          handleDirectorChange(
                            index,
                            "firstName",
                            e.target.value,
                          )
                        }
                        required
                      />
                    </Grid>

                    <Grid item xs={12} sm={6} md={3}>
                      <Typography fontWeight="bold">Last Name</Typography>
                      <input
                        type="text"
                        className="form-control"
                        value={director.lastName}
                        onChange={(e) =>
                          handleDirectorChange(
                            index,
                            "lastName",
                            e.target.value,
                          )
                        }
                        required
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      <Typography fontWeight="bold">Contact Number</Typography>
                      <input
                        type="text"
                        className="form-control"
                        maxLength={10}
                        value={director.contactNumber}
                        onChange={(e) => {
                          const value = e.target.value.replace(/\D/g, "");
                          if (value.length <= 10) {
                            handleDirectorChange(index, "contactNumber", value);
                          }
                        }}
                        required
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      <Typography fontWeight="bold">Email Address</Typography>
                      <input
                        type="email"
                        className="form-control"
                        value={director.email}
                        onChange={(e) =>
                          handleDirectorChange(index, "email", e.target.value)
                        }
                        required
                      />
                    </Grid>
                  </Grid>

                  <Box textAlign="right">
                    {directorData.length > 1 && (
                      <Button
                        variant="contained"
                        color="error"
                        size="small"
                        sx={{ mt: 2 }}
                        startIcon={<DeleteOutlineIcon />}
                        onClick={() => removeDirector(index)}
                      >
                        Remove
                      </Button>
                    )}
                  </Box>
                </Box>
              ))}

              <Box textAlign="right">
                <Button
                  variant="contained"
                  color="primary"
                  onClick={addDirector}
                  startIcon={<AddIcon />}
                >
                  Add
                </Button>
              </Box>
            </>
          )}

          {tabValue === 4 && (
            <>
              {employeeData.map((employee, index) => (
                <Box
                  key={employee.id}
                  sx={{
                    border: "1px solid #ddd",
                    borderRadius: 2,
                    mb: 3,
                    p: 3,
                  }}
                >
                  <Grid container spacing={2} mt={2}>
                    <Grid item xs={12} sm={6} md={4}>
                      <Typography fontWeight="bold">Employee Type</Typography>
                      <Select
                        isClearable
                        options={empTypeData}
                        value={empTypeData.find(
                          (opt) => opt.value === employee.employeeType,
                        )}
                        onChange={(selected) =>
                          handleEmployeeChange(
                            index,
                            "employeeType",
                            selected?.value,
                          )
                        }
                        placeholder="Select Employee Type"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <Typography fontWeight="bold">
                        Adult Male Count
                      </Typography>
                      <input
                        type="number"
                        className="form-control"
                        min="0"
                        value={employee.adultMale}
                        onChange={(e) =>
                          handleEmployeeChange(
                            index,
                            "adultMale",
                            e.target.value,
                          )
                        }
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <Typography fontWeight="bold">
                        Adult Female Count
                      </Typography>
                      <input
                        type="number"
                        className="form-control"
                        min="0"
                        value={employee.adultFemale}
                        onChange={(e) =>
                          handleEmployeeChange(
                            index,
                            "adultFemale",
                            e.target.value,
                          )
                        }
                      />
                    </Grid>
                  </Grid>

                  <Box textAlign="right">
                    {employeeData.length > 1 && (
                      <Button
                        variant="contained"
                        color="error"
                        size="small"
                        sx={{ mt: 2 }}
                        startIcon={<DeleteOutlineIcon />}
                        onClick={() => removeEmployee(index)}
                      >
                        Remove
                      </Button>
                    )}
                  </Box>
                </Box>
              ))}

              <Box textAlign="right">
                <Button
                  variant="contained"
                  color="primary"
                  onClick={addEmployee}
                  startIcon={<AddIcon />}
                >
                  Add
                </Button>
              </Box>
            </>
          )}

          {tabValue === 5 && (
            <>
              <TableContainer component={Paper}>
                <Table>
                  <TableHead>
                    <TableRow sx={{ backgroundColor: "#1976d2" }}>
                      <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                        Upload File
                      </TableCell>
                      <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                        File Name
                      </TableCell>
                      <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                        File Purpose
                      </TableCell>
                      <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                        Preview
                      </TableCell>
                      <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                        Action
                      </TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {documents.map((doc, index) => (
                      <TableRow key={index}>
                        {/* Upload Section */}
                        <TableCell>
                          <input
                            type="file"
                            accept="*/*"
                            ref={(el) => (fileInputRefs.current[index] = el)}
                            onChange={(e) => handleFileUpload(index, e)}
                            className="form-control"
                          />
                        </TableCell>

                        {/* File Name */}
                        <TableCell>
                          <input
                            type="text"
                            className="form-control"
                            value={doc.fileName}
                            readOnly
                          />
                        </TableCell>

                        <TableCell>
                          <textarea
                            className="form-control"
                            rows={2}
                            placeholder="Enter file purpose"
                            value={doc.filePurpose}
                            onChange={(e) =>
                              handlePurposeChange(index, e.target.value)
                            }
                          />
                        </TableCell>

                        <TableCell>
                          {doc.previewUrl ? (
                            doc.fileType.includes("pdf") ? (
                              <a
                                href={doc.previewUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                Download PDF
                              </a>
                            ) : (
                              <img
                                src={doc.previewUrl}
                                alt="preview"
                                style={{
                                  width: 100,
                                  height: 100,
                                  objectFit: "cover",
                                  borderRadius: 4,
                                }}
                              />
                            )
                          ) : (
                            <Typography color="textSecondary">
                              No Preview
                            </Typography>
                          )}
                        </TableCell>

                        {/* Actions */}
                        <TableCell>
                          <Box display="flex" gap={1}>
                            {documents.length > 1 && (
                              <Button
                                variant="contained"
                                color="error"
                                startIcon={<DeleteOutlineIcon />}
                                onClick={() => removeDocumentRow(index)}
                              >
                                Delete
                              </Button>
                            )}

                            {index === documents.length - 1 && (
                              <Button
                                variant="contained"
                                color="primary"
                                startIcon={<AddIcon />}
                                onClick={addDocumentRow}
                              >
                                Add
                              </Button>
                            )}
                          </Box>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </>
          )}

          {tabValue !== 0 && (
            <div className="bottombtn">
              <button
                className="btn btn-success"
                disabled={loading}
                onClick={handlesubmit}
              >
                Save
              </button>
              <button className="btn btn-danger" onClick={clearFields}>
                Reset
              </button>
            </div>
          )}
        </Box>
      )}

      <Dialog
        open={infoDialogOpen}
        maxWidth="sm"
        fullWidth
        onClose={() => setInfoDialogOpen(false)}
      >
        <DialogTitle sx={{ fontWeight: "bold", color: "#1976d2" }}>
          Important Information
        </DialogTitle>

        <DialogContent dividers>
          <Typography sx={{ mb: 1 }}>
            Welcome! Please take a moment to complete the required sections
            carefully.
          </Typography>

          <Typography sx={{ mb: 1 }}>
            To proceed successfully, ensure that you:
          </Typography>

          <Box component="ul" sx={{ pl: 3, mb: 1 }}>
            <li>
              <Typography>
                Visit <b>Basic Details</b> and fill all mandatory fields
              </Typography>
            </li>
            <li>
              <Typography>
                Complete <b>Factory Registration Details</b> accurately
              </Typography>
            </li>
            <li>
              <Typography>
                Provide <b>Director</b> and <b>Employee</b> information wherever
                applicable
              </Typography>
            </li>
            <li>
              <Typography>
                Upload all required documents in the <b>Upload Documents</b>{" "}
                section
              </Typography>
            </li>
          </Box>
        </DialogContent>

        <DialogActions sx={{ justifyContent: "center", pb: 2 }}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => setInfoDialogOpen(false)}
            sx={{ px: 4 }}
          >
            Got it
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={sessionExpiredOpen}
        maxWidth="sm"
        fullWidth
        disableEscapeKeyDown
        onClose={(event, reason) => {
          if (reason === "backdropClick") return;
        }}
      >
        <DialogTitle
          sx={{ fontWeight: "bold", color: "#2e7d32", textAlign: "center" }}
        >
          Data Saved Successfully
        </DialogTitle>

        <DialogContent dividers sx={{ textAlign: "center" }}>
          <Typography sx={{ fontSize: 16, mb: 1 }}>
            Your data has been saved successfully.
          </Typography>

          <Typography sx={{ fontSize: 15, color: "text.secondary" }}>
            Your session has expired for security reasons.
          </Typography>

          <Typography sx={{ fontSize: 14, mt: 1 }}>
            Please close this page or reopen using a new link.
          </Typography>
        </DialogContent>

        <DialogActions sx={{ justifyContent: "center", pb: 2 }}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              setSessionExpiredOpen(false);
              navigate("/notfound");
            }}
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
